export default function (initialDataInteractor, organizationId, name, memberIds) {
  let organizationToUpdate = {};

  initialDataInteractor.data.organizations.forEach(function (organization) {
    if (organization.organization_info.id == organizationId) {
      organizationToUpdate = organization;
    }
  });

  organizationToUpdate.name = name;
  organizationToUpdate.members = memberIds;

  // console.log(initialDataInteractor);
}